
import * as Types from "actions/types";
import { getUserDetailsPromise } from "actions/user";
import { Auth } from 'aws-amplify'
import history from './history' 


function signUp() {
  return {
    type: Types.SIGN_UP
  }
}

function signUpSuccess(user) {
  return {
    type: Types.SIGN_UP_SUCCESS,
    user
  }
}

function signUpFailure(error) {
  return {
    type: Types.SIGN_UP_FAILURE,
    error: {message: error}
  }
}

export function createUser(username, password, email, phone_number) {
  return (dispatch) => {
    dispatch(signUp())
    let phone
    const firstTwoDigits = phone_number.substring(0, 2)
    if (firstTwoDigits === '+1') {
      phone = phone_number
    } else {
      phone = '+1' + phone_number
    }
    Auth.signUp({
      username,
      password,
      attributes: {
        email,
        phone_number: phone
      }
    })
    .then(data => {
      console.log('data from signUp: ', data)
      dispatch(signUpSuccess(data))
      dispatch(showSignUpConfirmationModal())
    })
    .catch(err => {
      console.log('error signing up: ', err)
      dispatch(signUpFailure(err))
    });
  }
}

export function userLogout() {
  return (dispatch) => {
    dispatch(logOut())
    Auth.signOut()
      .then(user => {
        dispatch(logOutSuccess())
        history.push('/login');        
      })
      .catch(err => {
        dispatch(logOutFailure(err))
      });
  }  
}


function logOut() {
  return {
    type: Types.LOG_OUT
  }
}

function logOutSuccess() {
  return {
    type: Types.LOG_OUT_SUCCESS,
  }
}

function logOutFailure(error) {
  return {
    type: Types.LOG_OUT_FAILURE,
    error: {message: error}
  }
}


export function authenticate(username, password) {
  return (dispatch) => {
    dispatch(logIn())
    return Auth.signIn(username, password)
      .then(user => {
        dispatch(logInSuccess(user))
        dispatch(showSignInConfirmationModal())
        return getUserDetailsPromise(user, dispatch);
      })
      .then((result)=>{
        dispatch(retrieveSessionUserDetailsSuccess( result ));
        return Promise.resolve();
      })      
      .catch(err => {
        console.log('errror from signIn: ', err)
        dispatch(logInFailure(err))
      });
  }
}



function logIn() {
  return {
    type: Types.LOG_IN
  }
}

function logInSuccess(user) {
  return {
    type: Types.LOG_IN_SUCCESS,
    user
  }
}

function logInFailure(err) {

  let error = {};
  if(err.message){
    error = err;
  }else{
    error = {message: err}
  }

  return {
    type: Types.LOG_IN_FAILURE,
    error
  }
}


export function showSignInConfirmationModal() {
  return {
    type: Types.SHOW_SIGN_IN_CONFIRMATION_MODAL
  }
}

export function showSignUpConfirmationModal() {
  return {
    type: Types.SHOW_SIGN_UP_CONFIRMATION_MODAL
  }
}

export function confirmUserLogin(authCode) {
  return (dispatch, getState) => {
    dispatch(confirmLogIn())
    const { auth: { user }} = getState()
    console.log('state: ', getState())
    Auth.confirmSignIn(user, authCode)
      .then(data => {
        console.log('data from confirmLogin: ', data)
        dispatch(confirmLoginSuccess(data))
      })
      .catch(err => {
        console.log('error signing in: ', err)
        dispatch(confirmLoginFailure(err))
      })
  }
}

function confirmLogIn() {
  return {
    type: Types.CONFIRM_LOGIN
  }
}

function confirmLoginSuccess(user) {
  return {
    type: Types.CONFIRM_LOGIN_SUCCESS,
    user
  }
}

function confirmLoginFailure() {
  return {
    type: Types.CONFIRM_LOGIN_FAILURE,
    //user
  }
}

export function confirmUserSignUp(username, authCode) {
  return (dispatch) => {
    dispatch(confirmSignUp())
    Auth.confirmSignUp(username, authCode)
      .then(data => {
        console.log('data from confirmSignUp: ', data)
        dispatch(confirmSignUpSuccess())
      })
      .catch(err => {
        console.log('error signing up: ', err)
        dispatch(confirmSignUpFailure(err))
      });
  }
}

function confirmSignUp() {
  return {
    type: Types.CONFIRM_SIGNUP
  }
}

function confirmSignUpSuccess() {
  return {
    type: Types.CONFIRM_SIGNUP_SUCCESS
  }
}

function confirmSignUpFailure(error) {
  return {
    type: Types.CONFIRM_SIGNUP_FAILURE,
    error: {message: error}
  }
}


export function retrieveUserSession() {
  return (dispatch) => {
    dispatch(retrieveSession())
    Auth.currentAuthenticatedUser()
    .then((result) => {
      console.log(result);
      dispatch(retrieveSessionSuccess( result )); 
      return getUserDetailsPromise(result, dispatch);
    })
    .then((result)=>{
      dispatch(retrieveSessionUserDetailsSuccess( result )); 
    })
    .catch(err => {
        console.log('error retrieving session: ', err)
        dispatch(retrieveSessionFailure(err))
      });
  }
}


function retrieveSession() {
  return {
    type: Types.RETRIEVE_SESSION
  }
}

function retrieveSessionSuccess( user ) {
  return {
    type: Types.RETRIEVE_SESSION_SUCCESS,
    user,
  }
}

function retrieveSessionUserDetailsSuccess( userDetails ) {
  return {
    type: Types.RETRIEVE_SESSION_USER_DETAILS_SUCCESS,
    userDetails,
  }
}

function retrieveSessionFailure() {
  return {
    type: Types.RETRIEVE_SESSION_FAILURE
  }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js